import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";

type msg = {[key: string]: string};

export const useFormErrorMessages = (phoneNumber?: string): msg => {
  const {t} = useTranslation(I18nNamespace.WEB_SCHEDULING);

  const invalidEmail = t("Please enter a valid email address. Ex: yourname@example.com", {
    ns: "web-scheduling",
  });

  const requiredPhoneNumber = t("Phone number is required.", {
    ns: "web-scheduling",
  });
  const invalidPhoneNumber = t("Please enter a valid phone number.", {
    ns: "web-scheduling",
  });

  const requiredFirstName = t("First name is required.", {
    ns: "web-scheduling",
  });
  const requiredLastName = t("Last name is required.", {
    ns: "web-scheduling",
  });

  const requiredDate = t("Date of Birth is required.", {
    ns: "web-scheduling",
  });
  const invalidDate = t("Please enter a valid Date of Birth.", {
    ns: "web-scheduling",
  });
  const futureDate = t("Date of birth cannot be a future date.", {
    ns: "web-scheduling",
  });

  const tooYoungDate = phoneNumber
    ? t("For patients under 17, please have a parent or guardian call to book: {{phoneNumber}}", {
        ns: "web-scheduling",
        phoneNumber,
      })
    : t("For patients under 17, please call your local office to book an appointment.", {
        ns: "web-scheduling",
      });

  return {
    invalidEmail,
    requiredPhoneNumber,
    invalidPhoneNumber,
    requiredFirstName,
    requiredLastName,
    requiredDate,
    invalidDate,
    futureDate,
    tooYoungDate,
  };
};
